module.exports = __webpack_public_path__ + "static/media/customerSegments.1cb64562.svg";